import { api, unwrap } from '@saas-kit/lib';

export interface TenantFile {
  id: string;
  tenant_id: string;
  uploaded_by_user_id: string;
  name: string;
  content_type: string;
  size_bytes: number;
  visibility: string;
  created_at: string;
}

interface ListEnvelope {
  items: TenantFile[];
}

interface DownloadResult {
  url: string;
  expires_in_seconds: number;
}

export async function listFiles(): Promise<TenantFile[]> {
  const data = await unwrap<ListEnvelope>(api.get('/files'));
  return data.items;
}

export async function uploadFile(file: File): Promise<void> {
  const body = new FormData();
  body.append('uploaded_file', file);
  await unwrap(api.post('/files', body, { headers: { 'Content-Type': 'multipart/form-data' } }));
}

export async function getDownloadUrl(fileId: string): Promise<DownloadResult> {
  return unwrap<DownloadResult>(api.get(`/files/${fileId}/download`));
}
